<br>
<div class="row">
    <div class="col-sm-12">
        <div class="row form-group" *ngIf="WriteAction">
            <div class="col-sm-8">              
            </div>
            <div class="col-sm-4" style="margin-top: 10px;">
                <button style="float: right;" mat-raised-button (click)="add()" color="primary">
                    Add
                </button>
            </div>
        </div>
        <div style="width: 100%;">
            <table mat-table matSort matSortActive="noteType" matSortDirection="asc" matSortDisableClear [dataSource]="dataSource" style="width: 100%;">
                <ng-container matColumnDef="noteType">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Note Type </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.noteType}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="content">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Content </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.content}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="createdBy">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> User ID </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.createdBy}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="updatedDate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef> Date </th>
                    <td mat-cell *matCellDef="let element"> {{element.updatedDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>               
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row matRipple [ngClass]="{'row_select': row.noteId === this.note.noteId }" *matRowDef="let row; columns: displayedColumns;" (click)="edit(row)" ></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
    <div class="col-sm-12" [ngClass]="{disabledDiv: !WriteAction}" *ngIf="isShown">
        <div [formGroup]="notesFormGroup">
            <div class="row">
                <div class="col-sm-12">
                    <mat-form-field style="display:flex;flex-direction: column">
                        <mat-label>Note Type</mat-label>
                        <mat-select required formControlName="noteTypeId">
                            <mat-option>--Select--</mat-option>
                            <ng-container *ngFor="let item of noteTypeList">
                                <mat-option *ngIf="evalBind(item,note.noteTypeId)" [value]="item.id">
                                    {{item.description}}
                                </mat-option>
                          </ng-container>                           
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <mat-form-field style="display:flex;flex-direction: column;">
                        <mat-label>Content</mat-label>
                        <textarea matInput required placeholder="Content" maxlength="500" rows="8"
                            formControlName="content"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div align="end" *ngIf="WriteAction">
                <button mat-raised-button color="primary" [disabled]="!notesFormGroup.valid" (click)="onSubmit()">
                    {{this.note && this.note.noteId !== null ? 'Update': 'Save'}}
                </button>
                &nbsp;
                <button mat-raised-button (click)="cancel()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
